// Single entry point for Wasapi routes (imported once from dashboard.routes.js).
import { routes as crmRoutes } from './crm/routes';
import { routes as dashboardAppRoutes } from './dashboard-apps/routes';
import { routes as campaignRoutes } from './campaigns/routes';
import { routes as schedulerRoutes } from './scheduled-messages/routes';
import { routes as flowRoutes } from './flows/routes';
import { routes as appointmentRoutes } from './appointments/routes';
import { routes as internalChatRoutes } from './internal-chats/routes';
import { routes as projectRoutes } from './projects/routes';

export const routes = [
  ...crmRoutes,
  ...dashboardAppRoutes,
  ...campaignRoutes,
  ...schedulerRoutes,
  ...flowRoutes,
  ...appointmentRoutes,
  ...internalChatRoutes,
  ...projectRoutes,
];
